import "./CRDetails.css";

function CRDetails() {
	return (
		<div>
			<h1>This is a CR Detail section</h1>
		</div>
	);
}
export default CRDetails;
